import { Action } from '@ngrx/store';
import {
  WithoutMetaButAllowId,
  WithoutMeta,
  FireStoreDocument,
  DxDocument
} from '@digitaix/types';

export enum DocumentActionTypes {
  Load = '[Document] Load',
  Subscribe = '[Documnet] Subscribe',
  Create = '[Document] Create',
  CreateMany = '[Document] Create Many',
  Delete = '[Document] Delete',
  Update = '[Document] Update',
  Get = '[Document] Get',
  GetMany = '[Document] Get Many',
  CreateOrUpdate = '[Document] Create Or Update',

  Clear = '[Document] Clear',
  ClearAll = '[Document] Clear All',

  Archive = '[Document] Archive',
  Restore = '[Document] Restore',

  RequestDelete = '[Document] Request Delete',
  OpenDeleteDialog = '[Document] Open Delete Dialog',

  Created = '[Document] Created',
  Deleted = '[Document] Deleted',
  Updated = '[Document] Updated',

  AddMany = '[Document] Add Many',

  Added = '[Document] Added',
  Removed = '[Document] Removed',
  Modified = '[Document] Modified',

  Export = '[Document] Export',
  Import = '[Document] Import',

  Draft = '[Document] Draft',
  Template = '[Document] Template',
}

export class CreateFailed<T extends DxDocument> implements Action {
  public static TYPE = '@digitaix/core/documnets/CREATE_FAILED';
  public readonly type = CreateFailed.TYPE;

  constructor(
    public collectionPath: string,
    public document: WithoutMeta<T>,
    public error: any,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class UpdateFailed<T extends DxDocument> implements Action {
  public static TYPE = '@digitaix/core/documnets/UPDATE_FAILED';
  public readonly type = UpdateFailed.TYPE;

  constructor(
    public collectionPath: string,
    public documentId: string,
    public document: Partial<WithoutMeta<T>>,
    public error: any,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class DeleteFailed<T extends DxDocument> implements Action {
  public static TYPE = '@digitaix/core/documnets/DELETE_FAILED';
  public readonly type = DeleteFailed.TYPE;

  constructor(
    public collectionPath: string,
    public documentId: string,
    public error: any,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class OpenDeleteDialog implements Action {
  public readonly type = DocumentActionTypes.OpenDeleteDialog;

  constructor(
    public message: string,
    public collectionPath: string,
    public documentId: string,
    public tracer: string,
    public stack: string[],
  ) {}
}

export class ExportDocuments implements Action {
  public readonly type = DocumentActionTypes.Export;

  constructor(
    public payload?: {
      include?: string[];
      exclude?: string[];
    },
  ) {}
}

export class ImportDocuments implements Action {
  public readonly type = DocumentActionTypes.Import;

  constructor() {}
}

export class Clear implements Action {
  public readonly type = DocumentActionTypes.Clear;

  constructor(public collectionPath: string) {}
}

export class ClearAll implements Action {
  public readonly type = DocumentActionTypes.ClearAll;

  constructor(public withOut?: string[], public navigate: boolean = true) {}
}

export class ArchiveDocument implements Action {
  public readonly type = DocumentActionTypes.Archive;

  constructor(
    public collectionPath: string,
    public documentId,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class SetDocumentAsDraft implements Action {
  public readonly type = DocumentActionTypes.Draft;

  constructor(
    public collectionPath: string,
    public documentId,
    public draft?: boolean,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class SetDocumentAsTemplate implements Action {
  public readonly type = DocumentActionTypes.Template;

  constructor(
    public collectionPath: string,
    public documentId,
    public template?: boolean,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class RestoreDocument implements Action {
  public readonly type = DocumentActionTypes.Restore;

  constructor(
    public collectionPath: string,
    public documentId,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class DocumentCreated<D extends FireStoreDocument> implements Action {
  public readonly type = DocumentActionTypes.Created;

  constructor(
    public document: D | null,
    public collectionPath: string,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class DocumentDeleted implements Action {
  public readonly type = DocumentActionTypes.Deleted;

  /**
   * @deprecated use id property instead
   */
  public documentId: string;

  constructor(
    public id: string,
    public collectionPath: string,
    public tracer?: string,
    public stack?: string[],
  ) {
    // TODO fix deprecation warning
    // tslint:disable-next-line: deprecation
    this.documentId = id;
  }
}

export class DocumentUpdated<D extends FireStoreDocument> implements Action {
  public readonly type = DocumentActionTypes.Updated;

  constructor(
    public document: D | null,
    public collectionPath: string,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

// region http

export class LoadDocuments<Query> implements Action {
  public readonly type = DocumentActionTypes.Load;

  constructor(
    public collectionPath: string,
    public query?: Query,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class SubscribeDocuments<Query> implements Action {
  public readonly type = DocumentActionTypes.Subscribe;

  constructor(
    public collectionPath: string,
    public query?: Query,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class CreateDocument<T extends FireStoreDocument> implements Action {
  public readonly type = DocumentActionTypes.Create;

  constructor(
    public collectionPath: string,
    public document: WithoutMeta<T>,
    public id?: string,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class CreateOrUpdateDocument<T extends FireStoreDocument>
  implements Action {
  public readonly type = DocumentActionTypes.CreateOrUpdate;

  constructor(
    public collectionPath: string,
    public document: WithoutMetaButAllowId<T>,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class DeleteDocument implements Action {
  public readonly type = DocumentActionTypes.Delete;

  constructor(
    public collectionPath: string,
    public id: string,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class RequestDeleteDocument implements Action {
  public readonly type = DocumentActionTypes.RequestDelete;

  constructor(
    public collectionPath: string,
    public id: string,
    public tracer?: string,
    public stack?: string[],
    public message: string = '<p>Soll der Datensatz <b>unwiderruflich</b> gelÃ¶scht werden?</p>',
  ) {}
}

export class UpdateDocument<T extends FireStoreDocument> implements Action {
  public readonly type = DocumentActionTypes.Update;

  constructor(
    public collectionPath: string,
    public id: string,
    public document: Partial<WithoutMeta<T>>,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class CreateManyDocuments<T extends FireStoreDocument>
  implements Action {
  public readonly type = DocumentActionTypes.CreateMany;

  constructor(
    public collectionPath: string,
    public documents: Array<WithoutMeta<T>>,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class GetDocument implements Action {
  public readonly type = DocumentActionTypes.Get;

  constructor(
    public collectionPath: string,
    public id: string,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class GetManyDocument implements Action {
  public readonly type = DocumentActionTypes.GetMany;

  constructor(
    public collectionPath: string,
    public ids: string[],
    public tracer?: string,
    public stack?: string[],
  ) {}
}

// endregion

export interface DocumentStateChangeAction extends Action {
  collectionPath: string;
}

export class AddManyDocuments<T extends FireStoreDocument>
  implements DocumentStateChangeAction {
  public readonly type = DocumentActionTypes.AddMany;

  constructor(
    public collectionPath: string,
    public documents: T[],
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class DocumentAdded<T extends FireStoreDocument>
  implements DocumentStateChangeAction {
  public readonly type = DocumentActionTypes.Added;

  constructor(
    public collectionPath: string,
    public document: T,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class DocumentRemoved implements DocumentStateChangeAction {
  public readonly type = DocumentActionTypes.Removed;

  constructor(
    public collectionPath: string,
    public id: string,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export class DocumentModified<T extends FireStoreDocument>
  implements DocumentStateChangeAction {
  public readonly type = DocumentActionTypes.Modified;

  constructor(
    public collectionPath: string,
    public document: T,
    public tracer?: string,
    public stack?: string[],
  ) {}
}

export type DocumentActions<T extends FireStoreDocument, Query> =
  | LoadDocuments<Query>
  | SubscribeDocuments<Query>
  | CreateDocument<T>
  | CreateOrUpdateDocument<T>
  | DeleteDocument
  | UpdateDocument<T>
  | GetDocument
  | RestoreDocument
  | ArchiveDocument
  | GetManyDocument
  | RequestDeleteDocument
  | DocumentCreated<T>
  | DocumentDeleted
  | Clear
  | ClearAll
  | DocumentUpdated<T>
  | DocumentAdded<T>
  | AddManyDocuments<T>
  | DocumentModified<T>
  | DocumentRemoved;
